import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { Image, Divider, Button, Typography, Tag, message } from 'antd';

import { setEngineDisabled } from './engineSlice';

const { Title, Text } = Typography;

// TODO: this exists because the URL changes all the time and will likely have to be fixed again
const FALLBACK_ICON_URL =
  'https://stg.nomnomdata.com/static/favicon/apple-touch-icon.png';
const REPLACEMENT_ICON_URL =
  'http://appdev.nomnomdata.com/static/favicon/apple-touch-icon.png';

function iconUrlFor(model) {
  let url;
  try {
    url = model.icons['1x'].url;
  } catch (err) {
    url = FALLBACK_ICON_URL;
  }
  if (!url || url === FALLBACK_ICON_URL) {
    return REPLACEMENT_ICON_URL;
  }
  return url;
}

function Engine({ engine, canManage }) {
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);

  const model = engine.models[0];
  const hidden = !!engine.disabled;
  const categories = model.categories || [];

  const toggleHidden = async () => {
    setSaving(true);
    try {
      unwrapResult(
        await dispatch(
          setEngineDisabled({ uuid: engine.uuid, disabled: !hidden }),
        ),
      );
    } catch (err) {
      message.error(
        `Could not ${hidden ? 'show' : 'hide'} ${model.alias}. Please try again.`,
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className={'engine-row' + (hidden ? ' engine-row--hidden' : '')}>
        <div className="engine-row__icon">
          <Image width={40} src={iconUrlFor(model)} alt={model.alias} />
        </div>
        <div className="engine-row__info">
          <Title level={5}>
            {model.alias}
            {hidden && (
              <Tag style={{ marginLeft: 8, verticalAlign: 'middle' }}>
                Hidden
              </Tag>
            )}
          </Title>
          <Text type="secondary" className="engine-row__description">
            {model.description}
          </Text>
        </div>
        {categories.length > 0 && (
          <div className="engine-row__categories">
            {categories.map((category) => (
              <Tag key={category.name}>{category.name}</Tag>
            ))}
          </div>
        )}
        {canManage && (
          <div className="engine-row__action">
            <Button
              type={hidden ? 'primary' : 'default'}
              loading={saving}
              onClick={toggleHidden}
              aria-label={`${hidden ? 'Show' : 'Hide'} ${model.alias}`}
            >
              {hidden ? 'Show' : 'Hide'}
            </Button>
          </div>
        )}
      </div>
      <Divider style={{ margin: 0 }} />
    </>
  );
}

export default Engine;
